import { render, staticRenderFns } from "./tipo.vue?vue&type=template&id=f07ce00a"
import script from "./tipo.vue?vue&type=script&lang=js"
export * from "./tipo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports